export default "__VITE_ASSET__c191952d__"